"use client";

import { useEffect } from "react";

const ZENDESK_SNIPPET_ID = "ze-snippet";
const ZENDESK_SNIPPET_SRC =
  "https://static.zdassets.com/ekr/snippet.js?key=3ddfa314-91a5-47e6-8e54-2d1c4dcc8a50";

export default function ZendeskSnippet() {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") return;
    if (navigator.webdriver) return;

    const timeoutId = window.setTimeout(() => {
      if (document.getElementById(ZENDESK_SNIPPET_ID)) return;

      const script = document.createElement("script");
      script.id = ZENDESK_SNIPPET_ID;
      script.src = ZENDESK_SNIPPET_SRC;
      script.async = true;
      document.body.appendChild(script);
    }, 2000);

    return () => window.clearTimeout(timeoutId);
  }, []);

  return null;
}
